import React, { useState } from "react"
import jsonp from "jsonp"
import PropTypes from "prop-types"

const defaultMessages = {
	sending: "Sending...",
	success: "Thank you for subscribing!",
	error: "An unexpected internal error has occurred.",
	empty: "You must write an e-mail.",
	duplicate: "Too many subscribe attempts for this email address",
	button: "Subscribe!",
}

const Mailchimp = ({ fields, action, styles, className, formClassName, messages }) => {
	const [status, setStatus] = useState("")
	const [fieldValues, setFieldValues] = useState({})

	const mergedMessages = { ...defaultMessages, ...messages }

	const getButtonMsg = () => {
		switch (status) {
			case "sending":
				return mergedMessages.sending
			case "success":
				return mergedMessages.success
			case "duplicate":
				return mergedMessages.duplicate
			case "empty":
				return mergedMessages.empty
			case "error":
				return mergedMessages.error
			default:
				return mergedMessages.button
		}
	}

	const sendData = (url) => {
		setStatus("sending")
		jsonp(url, { param: "c" }, (err, data) => {
			if (data.msg.includes("already subscribed")) {
				setStatus("duplicate")
			} else if (err) {
				setStatus("error")
			} else if (data.result !== "success") {
				setStatus("error")
			} else {
				setStatus("success")
			}
		})
	}

	const handleSubmit = (evt) => {
		evt.preventDefault()
		const values = fields
			.map((field) => `${field.name}=${encodeURIComponent(fieldValues[field.name] || "")}`)
			.join("&")
		const path = `${action}&${values}`
		const url = path.replace("/post?", "/post-json?")
		const regex = /^([\w_\.\-\+])+\@([\w\-]+\.)+([\w]{2,10})+$/
		const email = fieldValues["EMAIL"]
		!regex.test(email) ? setStatus("empty") : sendData(url)
	}

	return (
		<form
			onSubmit={handleSubmit}
			className={`${className} ${formClassName}`}
		>
			<div className="inner">
				<div className="form-row">
					{fields.map((input) => (
						<input
							className="fRegIt"
							{...input}
							key={input.name}
							onChange={({ target }) =>
								setFieldValues(prev => ({ ...prev, [input.name]: target.value }))
							}
							defaultValue={fieldValues[input.name]}
						/>
					))}
				</div>
				<div className="form-row">
					<button
						disabled={status === "sending" || status === "success"}
						type="submit"
						className=" has-icon chevron-e"
						data-tip=""
					>
						<span>{getButtonMsg()}</span>
					</button>
				</div>
			</div>
		</form>
	)
}

Mailchimp.defaultProps = {
	messages: {},
	buttonClassName: "",
	styles: {
		sendingMsg: { color: "#0652DD" },
		successMsg: { color: "#009432" },
		duplicateMsg: { color: "#EE5A24" },
		errorMsg: { color: "#ED4C67" },
	},
}

Mailchimp.propTypes = {
	action: PropTypes.string,
	messages: PropTypes.object,
	fields: PropTypes.array,
	styles: PropTypes.object,
	className: PropTypes.string,
	buttonClassName: PropTypes.string,
}

export default Mailchimp
